import React from "react";
import { useRestartDataload } from "./useRestartDataload";
import { Redirect } from "react-router";
import Loading from "./Loading";
import { Container, Row, Col } from "react-bootstrap";

const RestartDataload = () => {
  const { restart } = useRestartDataload();

  if (restart) {
    return (
      <Container>
        <Row>
          <Col>
            <Loading />
          </Col>
        </Row>
      </Container>
    );
  } else {
    return <Redirect to="/" />;
  }

  // console.log("CodeDeploy form: ", formData);
  // console.log("Data Records: ", datarecords);
};

export default RestartDataload;
